module.exports = __webpack_public_path__ + "static/media/daibiao-title-5.ad59f70f.png";